import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { LetterStatus } from '../types/game.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterTile',
  props: {
    letter: {},
    status: {}
  },
  setup(__props: any) {

const props = __props;

const statusClass = computed(() => {
  switch (props.status) {
    case 'correct':
      return 'bg-red-500 text-white';
    case 'present':
      return 'bg-yellow-500 text-black';
    case 'absent':
      return 'bg-gray-400 text-white';
    default:
      return 'bg-white text-black';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["letter-tile flex items-center justify-center font-bold rounded border border-gray-300", statusClass.value])
  }, _toDisplayString(_ctx.letter), 3))
}
}

})